import type {ShadowOrGlowOptionsObject} from '@Utils/fabric-shadow.util';
import {convertFabricShadowObjectToShadowOrGlowOptionsObject} from '@Utils/fabric-shadow.util';
import {useGetSlideShowItemWithSelectedSlide} from '@Hooks/poster-editor/useGetSlideshowItemWithSelectedSlide';
import {useMemo} from 'react';
import {useGetKeyFromActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromActiveSlideItem';

export function useGetShadowOptionsObjectOfActiveSlideItem(): ShadowOrGlowOptionsObject | null | undefined {
  const {activeSlide} = useGetSlideShowItemWithSelectedSlide();

  const activeSlideShadow = useGetKeyFromActiveSlideItem('shadow');

  if (activeSlideShadow === undefined) {
    throw new Error('activr slide item does not have shadow property');
  }

  return useMemo(() => {
    return convertFabricShadowObjectToShadowOrGlowOptionsObject(activeSlideShadow, activeSlide.getScaleForShadow());
  }, [activeSlideShadow, activeSlide]);
}
